import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import * as AuthActions from 'app/main/auth/store/auth.actions';

import { AuthState } from 'app/main/auth/store/auth.reducer';
import { Store } from '@ngrx/store';
import { getAuthData } from 'app/main/auth/store/auth.selectors';
import { AuthData } from 'app/main/auth/auth-data.model';
import { locale as English } from './i18n/en';
import { locale as French } from './i18n/fr'
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { CONTROLE_ACCES, PARAMETRER_APP } from 'app/shared/service/auth-guard.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { PrimeNGConfig } from 'primeng/api';
import { DateAdapter } from '@angular/material/core';
import { FuseNavigationItem } from '@fuse/types';
import { PrivilegeEnum } from 'app/main/privilege/privilege.enum';
import { AppConfigService } from 'app/shared/service/app-config.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NotificationAddFormComponent } from 'app/main/notification-chat/notification-add-form/notification-add-form.component';


@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy {
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];
    dialogRef: any;
    authData$: Observable<AuthData>;
    authData: AuthData;
    isAdmin: boolean;



    // Private
    private _unsubscribeAll: Subject<any>;


    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {TranslateService} _translateService
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private _translateService: TranslateService,
        private _store: Store<AuthState>,
        private _configService: AppConfigService,
        private router: Router,
        private _http: HttpClient,
        private dialog: MatDialog,
        private _tranlationLoaderService: FuseTranslationLoaderService,
        private _fuseNavigationService: FuseNavigationService,
        private primeNGConfig: PrimeNGConfig,
        private dateAdapter: DateAdapter<Date>
    ) {
        this._tranlationLoaderService.loadTranslations(English, French);

        // Set the defaults
        this.userStatusOptions = [
            {
                title: 'Online',
                icon: 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Away',
                icon: 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'Do not Disturb',
                icon: 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Invisible',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD'
            },
            {
                title: 'Offline',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];

        this.languages = [
            {
                id: 'en',
                title: 'English',
                flag: 'us'
            },
            {
                id: 'fr',
                title: 'Français',
                flag: 'fr'
            }
        ];

        this.navigation = null;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                this.horizontalNavbar = settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });

        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, { id: this._translateService.currentLang });


        this.authData$ = this._store.select(getAuthData);

        this.authData$.subscribe(
            data => {
                if (data) {
                    this.initNavigation(data);
                    this.authData = data;
                    this.isAdmin = (this.authData?.role === 'ADMIN');
                    console.log('isAdmin', this.isAdmin);

                }
            }
        );
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    /**
     * Search
     *
     * @param value
     */
    search(value): void {
        // Do your search here...
        console.log(value);
    }

    /**
     * Set the language
     *
     * @param lang
     */
    setLanguage(lang): void {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this._translateService.use(lang.id);

        localStorage.setItem('lang', lang.id);

        this.dateAdapter.setLocale(lang.id);


        this._translateService.get('App.PrimeNGConfig').subscribe(res => this.primeNGConfig.setTranslation(res));
    }

    logout() {
        this._store.dispatch(new AuthActions.DoLogoutAction());
    }
    redirect() {
        const url = `${this._configService.config.apiUrl}/profile`;

        this.router.navigate(['/profile']); // Remplacez 'profile' par la route définie dans Angular

    }
    redirectToProfileForm(): void {
        this.router.navigate(['/qualisys-profile']);
    }
    notif() {

        let dialogRef = this.dialog.open(NotificationAddFormComponent, {
            panelClass: 'app-notification-add-form',
            disableClose: true,

        });
        dialogRef.afterClosed().subscribe(result => {

        });



    }
    private initNavigation(data: AuthData) {

        //this._fuseNavigationService.removeNavigationItem('applications');

        let navigations = [];

        navigations.push({
            id: 'dashboard',
            title: this._translateService.instant('NAV.DASHBOARD'),
            translate: 'NAV.DASHBOARD',
            icon: 'dashboard',
            type: 'item',
            url: '/dashboard',
        });
        // if (data.authorities.includes(PrivilegeEnum.AMELIORATION_CONTINUE)) {
        if (data.authorities.some(authority => authority.includes(PrivilegeEnum.AMELIORATION_CONTINUE))) {
            navigations.push({
                'id': 'GNC',
                'title': this._translateService.instant('NAV.GNC'),
                'translate': 'NAV.GNC',
                'type': 'collapsable',
                'icon': 'feedback',
                'children': [
                    {
                        id: 'non-conformite',
                        title: this._translateService.instant('NAV.NON-CONFORMITE'),
                        translate: 'NAV.NON-CONFORMITE',
                        type: 'item',
                        icon: 'feedback',
                        url: '/non-conformites'
                    },
                    {
                        id: 'reclamations',
                        title: this._translateService.instant('NAV.RECLAMATION'),
                        translate: 'NAV.RECLAMATION',
                        type: 'item',
                        icon: 'assignment',
                        url: '/reclamations'
                    },
                    {
                        id: 'actions',
                        title: this._translateService.instant('NAV.ACTIONS'),
                        translate: 'NAV.ACTIONS',
                        type: 'item',
                        icon: 'check_box',
                        url: '/taches-ouvertes'
                    },
                    {
                        id: 'calendar',
                        title: this._translateService.instant('NAV.CALENDAR'),
                        translate: 'NAV.CALENDAR',
                        type: 'item',
                        icon: 'today',
                        url: '/calendar'
                    },
                    {
                        id: 'bilan-analyse',
                        title: this._translateService.instant('NAV.BILAN_ANALYSE'),
                        translate: 'NAV.BILAN_ANALYSE',
                        type: 'item',
                        icon: 'table_chart',
                        url: '/dashboard/pivot'
                    },
                    {
                        id: 'enquetes',
                        title: this._translateService.instant('NAV.ENQUETE'),
                        translate: 'NAV.ENQUETE',
                        type: 'item',
                        icon: 'playlist_add_check',
                        url: '/enquetes'
                    },
                    /**************RATING***************************/
                    {
                        id: 'ratings',
                        title: this._translateService.instant('NAV.BORNE'),
                        translate: 'NAV.BORNE',
                        type: 'collapsable',
                        icon: 'rate_review',
                        children: [
                            {
                                id: 'Rating',
                                title: this._translateService.instant('NAV.SETTING'),
                                translate: 'NAV.SETTING',
                                icon: 'rate_review',
                                type: 'item',
                                url: '/ratings'
                            },
                            {
                                id: 'Compagne',
                                title: this._translateService.instant('NAV.COMPAGNE'),
                                translate: 'NAV.COMPAGNE',
                                icon: 'library_books',
                                type: 'item',
                                url: '/compagnes'
                            },



                        ],
                    },

                ]
            });
        }
        // let nav = <FuseNavigationItem>{};
        // nav.id = 'GED';
        // nav.title = 'Gestion Électronique des Documents';
        // nav.translate = 'NAV.GED';
        // nav.icon = 'folder_open';
        // nav.type = 'item';
        // nav.url = '/ged';
        // navigations.push(nav);
        if (data.authorities.some(authority => authority.includes(PrivilegeEnum.GESTION_DOCUMENTAIRE))) {
            navigations.push({
                'id': 'GED',
                'title': this._translateService.instant('NAV.GED'),
                'translate': 'NAV.GED',
                'type': 'collapsable',
                'icon': 'folder_open',
                'children': [

                    {
                        'id': 'Documents',
                        'title': this._translateService.instant('NAV.DOCS'),
                        'translate': 'NAV.DOCS',
                        'type': 'collapsable',
                        'icon': 'description',
                        'children': [
                            {
                                id: 'recent',
                                title: this._translateService.instant('NAV.RECENT'),
                                translate: 'NAV.RECENT',
                                type: 'item',
                                icon: 'history',
                                url: '/recent'
                            },
                            {
                                id: 'docs_internes',
                                title: this._translateService.instant('NAV.DOCS_INTERNES'),
                                translate: 'NAV.DOCS_INTERNES',
                                type: 'item',
                                icon: 'insert_drive_file',
                                url: '/ged'
                            },
                            {
                                id: 'docs_externes',
                                title: this._translateService.instant('NAV.DOCS_EXTERNES'),
                                translate: 'NAV.DOCS_EXTERNES',
                                type: 'item',
                                icon: 'file_copy',
                                url: '/doc-externes'
                            },
                            {
                                id: 'list_docs_internes',
                                title: this._translateService.instant('NAV.TAB_BORD'),
                                translate: 'NAV.TAB_BORD',
                                type: 'item',
                                icon: 'event_note',
                                url: '/docs-interne'
                            }

                        ]
                    },
                    {
                        'id': 'Enregistrements',
                        'title': this._translateService.instant('NAV.ENREGISTREMENTS'),
                        'translate': 'NAV.ENREGISTREMENTS',
                        'type': 'collapsable',
                        'icon': 'save',
                        'children': [
                            {
                                id: 'forms',
                                title: this._translateService.instant('NAV.FORMS'),
                                translate: 'NAV.FORMS',
                                type: 'item',
                                icon: 'featured_play_list',
                                url: '/formulaires'
                            },
                            {
                                id: 'records',
                                title: this._translateService.instant('NAV.EDITIONS'),
                                translate: 'NAV.EDITIONS',
                                type: 'item',
                                icon: 'save',
                                url: '/records'
                            },
                            {
                                id: 'papiers',
                                title: this._translateService.instant('NAV.PAPIERS'),
                                translate: 'NAV.PAPIERS',
                                type: 'item',
                                icon: 'receipt',
                                url: '/records-papers'
                            },
                            {
                                id: 'suivi_enregistrements',
                                title: this._translateService.instant('NAV.TAB_BORD'),
                                translate: 'NAV.TAB_BORD',
                                type: 'item',
                                icon: 'assignment',
                                url: '/records-tracking'
                            }

                        ]
                    },
                    {
                        id: 'stat',
                        title: this._translateService.instant('NAV.GED_STAT'),
                        translate: 'NAV.GED_STAT',
                        type: 'item',
                        icon: 'bar_chart',
                        url: '/stat'
                    },


                ]
            });
        }
        /***********************PROLAB STOCK *********************************/
        if (data.authorities.some(authority => authority.includes(PrivilegeEnum.STOCK))) {
            navigations.push({
                id: 'stock',
                title: this._translateService.instant('NAV.STOCK'),
                translate: 'NAV.STOCK',
                type: 'collapsable',
                icon: 'storage',
                children: [
                    {
                        id: 'stock',
                        title: this._translateService.instant('NAV.LOT_EN_STOCK'),
                        translate: 'NAV.LOT_EN_STOCK',
                        type: 'item',
                        icon: 'swap_horiz',
                        url: '/stocks'
                    },
                    {
                        id: 'article',
                        title: this._translateService.instant('NAV.ARTICLE'),
                        translate: 'NAV.ARTICLE',
                        type: 'item',
                        icon: 'category',
                        url: '/articles'
                    },
                    {
                        id: 'bon',
                        title: this._translateService.instant('NAV.BCMD'),
                        translate: 'NAV.BCMD',
                        type: 'item',
                        icon: 'receipt',
                        url: '/bons'
                    },
                    {
                        id: 'bonreception',
                        title: this._translateService.instant('NAV.BRECEP'),
                        translate: 'NAV.BRECEP',
                        type: 'item',
                        icon: 'assignment_returned',
                        url: '/bonreceptions'
                    },
                    {
                        id: 'bonsortie',
                        title: this._translateService.instant('NAV.BOUT'),
                        translate: 'NAV.BOUT',
                        type: 'item',
                        icon: 'exit_to_app',
                        url: '/bonsorties'
                    },
                    {
                        id: 'bonentree',
                        title: this._translateService.instant('NAV.BIN'),
                        translate: 'NAV.BIN',
                        type: 'item',
                        icon: 'assignment_return',
                        url: '/bonentrees'
                    },
                    {
                        id: 'bonretour',
                        title: this._translateService.instant('NAV.BRET'),
                        translate: 'NAV.BRET',
                        type: 'item',
                        icon: 'assignment_late',
                        url: '/bonretours'
                    },
                    {
                        id: 'inventaire',
                        title: this._translateService.instant('NAV.INVENTAIRE'),
                        translate: 'NAV.INVENTAIRE',
                        type: 'item',
                        icon: 'assignment_turned_in',
                        url: '/inventaires'
                    },
                    {
                        id: 'facture',
                        title: this._translateService.instant('NAV.FACTURE'),
                        translate: 'NAV.FACTURE',
                        type: 'item',
                        icon: 'view_list',
                        url: '/factures'
                    },
                    {
                        id: 'reglement',
                        title: this._translateService.instant('NAV.REGLEMENT'),
                        translate: 'NAV.REGLEMENT',
                        type: 'item',
                        icon: 'payment',
                        url: '/reglements'
                    },
                    {
                        id: 'situationfournisseur',
                        title: this._translateService.instant('NAV.SITUATION_FOURNISSEUR'),
                        translate: 'NAV.SITUATION_FOURNISSEUR',
                        icon: 'group',
                        type: 'item',
                        url: '/situationfournisseurs',
                    },
                    {
                        id: 'caisse',
                        title: this._translateService.instant('NAV.CAISSE'),
                        translate: 'NAV.CAISSE',
                        type: 'item',
                        icon: 'card_travel',
                        url: '/caisses'
                    },
                    /* {
                        id: 'demandeachat',
                        title: 'Demande Achat',
                        translate: 'NAV.DEMANDEACHAT',
                        type: 'item',
                        icon: 'add_shopping_cart',
                        url: '/demandeachats'
                    },
                    */
                ]

            });
        }

        /***********************PROLAB STOCK *********************************/

        /***********************Evalution Fournisseur *********************************/
        if (data.authorities.some(authority => authority.includes(PrivilegeEnum.EVAL))) {
            navigations.push({
                id: 'eval',
                title: this._translateService.instant('NAV.EVAL'),
                translate: 'NAV.EVAL',
                type: 'collapsable',
                icon: 'assessment',
                children: [
                   
                    {
                        id: 'categoriefournisseur',
                        title: this._translateService.instant('NAV.CATEGORIE_FOURNISSEUR'),
                        translate: 'NAV.CATEGORIE_FOURNISSEUR',
                        type: 'item',
                        icon: 'category',
                        url: '/categoriefournisseurs'
                    },
                    {
                        id: 'evaluationcategoriefournisseur',
                        title: this._translateService.instant('NAV.EVALUATION_CATEGORIE_FOURNISSEUR'),
                        translate: 'NAV.EVALUATION_CATEGORIE_FOURNISSEUR',
                        type: 'item',
                        icon: 'assessment_outlined',
                        url: '/evaluationcategoriefournisseurs'
                    },
                ]
            });
        }
        /***********************Evalution Fournisseur *********************************/

        if (data.authorities.some(authority => authority.includes(PrivilegeEnum.RESSOURCE_HUMAINE))) {
            navigations.push({
                'id': 'GRH',
                'title': this._translateService.instant('NAV.GRH'),
                'translate': 'NAV.GRH',
                'type': 'collapsable',
                'icon': 'account_box',
                'children': [
                    {
                        id: 'employes',
                        title: this._translateService.instant('NAV.EMPLOYES'),
                        translate: 'NAV.EMPLOYES',
                        type: 'item',
                        icon: 'supervisor_account',
                        url: '/employes'
                    },
                    {
                        id: 'postes',
                        title: this._translateService.instant('NAV.POSTE'),
                        translate: 'NAV.POSTE',
                        type: 'item',
                        icon: 'contact_mail',
                        url: '/postes'
                    },
                    {
                        id: 'questionnaires',
                        title: this._translateService.instant('NAV.QUESTIONNAIRE'),
                        translate: 'NAV.QUESTIONNAIRE',
                        type: 'item',
                        icon: 'question_answer',
                        url: '/questionnaires'
                    }
                ]
            });
        }
        if (data.authorities.some(authority => authority.includes(PrivilegeEnum.INDICATEUR))) {
            navigations.push({
                id: 'indicateurs',
                title: this._translateService.instant('NAV.INDICATEUR'),
                translate: 'NAV.INDICATEUR',
                type: 'item',
                icon: 'trending_up',
                url: '/indicateurs'
            });
        }
        /* navigations.push({
            id: 'audits',
            title: 'Audits',
            translate: 'NAV.AUDIT',
            type: 'item',
            icon: 'trending_up',
            url: '/audits'
        }); */
        // navigations.push({
        //     id: 'audits',
        //     title: 'Audits',
        //     translate: 'NAV.AUDITS',
        //     type: 'item',
        //     icon: 'rate_review',
        //     url: '/audits'
        // });

        // navigations.push({
        //     id: 'gmao',
        //     title: 'GMAO',
        //     //translate: 'NAV.RISK_MANGEMENT',
        //     type: 'item',
        //     icon: 'important_devices',
        //     url: '/gmao'

        // });

        // navigations.push({
        //     id: 'risk',
        //     title: 'Gestion des risques',
        //     translate: 'NAV.RISK_MANGEMENT',
        //     type: 'item',
        //     icon: 'sync_problem',
        //     url: '/risk'
        // });

        /********************GMAO *******************************/
        if (data.authorities.some(authority => authority.includes(PrivilegeEnum.GMAO))) {
            navigations.push({
                'id': 'gmao',
                'title': this._translateService.instant('NAV.GMAO'),
                'translate': 'NAV.GMAO',
                'type': 'collapsable',
                'icon': 'important_devices',
                'children': [{
                    id: 'equipement',
                    title: this._translateService.instant('NAV.EQUIPEMENT'),
                    translate: 'NAV.EQUIPEMENT',
                    icon: 'devices',
                    type: 'item',
                    url: '/equipements',
                },
                {
                    id: 'panne',
                    title: this._translateService.instant('NAV.PANNE'),
                    translate: 'NAV.PANNE',
                    type: 'item',
                    icon: 'bug_report',
                    url: '/pannes'
                },
                {
                    'id': 'maintenance',
                    'title': this._translateService.instant('NAV.MAINTENANCE'),
                    'translate': 'NAV.MAINTENANCE',
                    'type': 'collapsable',
                    'icon': 'settings',
                    'children': [
                        {
                            id: 'intervention',
                            title: this._translateService.instant('NAV.INTERVENTION'),
                            translate: 'NAV.INTERVENTION',
                            type: 'item',
                            icon: 'assignment_turned_in',
                            url: '/interventions'
                        },
                        {
                            id: 'tache',
                            title: this._translateService.instant('NAV.TACHE'),
                            translate: 'NAV.TACHE',
                            type: 'item',
                            icon: 'description',
                            url: '/tasks'
                        },
                        {
                            id: 'piece',
                            title: this._translateService.instant('NAV.PIECE'),
                            translate: 'NAV.PIECE',
                            type: 'item',
                            icon: 'work_outline',
                            url: '/pieces'
                        }]
                }


                ]
            });
        }
        /*********************************GMAO ******************/
        /*********************************RISK *****************/
        if (data.authorities.some(authority => authority.includes(PrivilegeEnum.RISQUE))) {
            navigations.push({
                id: 'riskGestion des risques',
                title: this._translateService.instant('NAV.RISK_MANGEMENT'),
                translate: 'NAV.RISK_MANGEMENT',
                type: 'collapsable',
                icon: 'sync_problem',
                children: [
                    {
                        id: 'risk',
                        title: this._translateService.instant('NAV.RISK'),
                        translate: 'NAV.RISK',
                        type: 'item',
                        icon: 'sync_problem',
                        url: '/risks'
                    },
                    {
                        id: 'Avertissement',
                        title: this._translateService.instant('NAV.HIGHRISK'),
                        translate: 'NAV.HIGHRISK',
                        type: 'item',
                        icon: 'warning',
                        url: '/high-risks',
                    }
                ]

            });
        }
        /*******************************RISK ********************************/

        /***********************REVUE DE DIRECTION *********************************/
        if (data.authorities.some(authority => authority.includes(PrivilegeEnum.REVUE_DIRECTION))) {
            navigations.push({

                id: 'revue_direction',
                title: this._translateService.instant('NAV.REVUE_DIRECTION'),
                translate: 'NAV.REVUE_DIRECTION',
                type: 'item',
                icon: 'info',
                url: '/revuedirections'

            });
        }

        /***********************REVUE DE DIRECTION *********************************/


        /***********************AUDIT *********************************/
        if (data.authorities.some(authority => authority.includes(PrivilegeEnum.AUDIT))) {
            navigations.push({
                id: 'audits',
                title: this._translateService.instant('NAV.AUDITS'),
                translate: 'NAV.AUDITS',
                type: 'item',
                icon: 'check_circle',//visibility
                url: '/audits'
            });
        }
        /***********************AUDIT *********************************/



        if (data.authorities.some(authority => authority.includes(PrivilegeEnum.PARAMETRER_APP))) {
            navigations.push({
                'id': 'setting',
                'title': this._translateService.instant('NAV.SETTING'),
                'translate': 'NAV.SETTING',
                'type': 'collapsable',
                'icon': 'build',
                'children': [
                    {
                        'id': 'general',
                        'title': this._translateService.instant('NAV.GENERAL'),
                        'translate': 'NAV.GENERAL',
                        'type': 'collapsable',
                        'icon': 'settings',
                        'children': [
                            {
                                id: 'pays',
                                title: this._translateService.instant('NAV.PAYS'),
                                translate: 'NAV.PAYS',
                                icon: 'public',
                                type: 'item',
                                url: '/pays',
                            },
                            {
                                id: 'city',
                                title: this._translateService.instant('NAV.CITY'),
                                translate: 'NAV.CITY',
                                icon: 'map',
                                type: 'item',
                                url: '/villes',
                            },
                            {
                                id: 'processus',
                                title: this._translateService.instant('NAV.PROCESS'),
                                translate: 'NAV.PROCESS',
                                icon: 'layers',
                                type: 'item',
                                url: '/processus',
                            },
                            {
                                id: 'actionlog',
                                title: this._translateService.instant('NAV.ACTIONLOG'),
                                translate: 'NAV.ACTIONLOG',
                                icon: 'history',
                                type: 'item',
                                url: '/actionlogs',
                            },
                            {
                                id: 'rappel',
                                title: this._translateService.instant('NAV.RAPPEL'),
                                translate: 'NAV.RAPPEL',
                                icon: 'schedule',
                                type: 'item',
                                url: '/rappels',
                            },
                            {
                                id: 'options-generales',
                                title: this._translateService.instant('NAV.OPTIONS_GENERALES'),
                                translate: 'NAV.OPTIONS_GENERALES',
                                icon: 'settings',
                                type: 'item',
                                url: '/options-generales',
                            }
                        ]
                    },
                    /* {
                        id: 'audits',
                        title: 'Gestion des audits',
                        translate: 'Audits',
                        type: 'collapsable',
                        icon: 'sync_problem',
                        children: [
                            {
                                id: 'Norme',
                                title: 'Norme',
                                translate: 'Norme',
                                icon: 'autorenew',
                                type: 'item',
                                url: '/normes'
                            },

                        ],
                    }, */

                    {
                        'id': 'NC',
                        'title': this._translateService.instant('NAV.GNC'),
                        'translate': 'NAV.GNC',
                        'type': 'collapsable',
                        'icon': 'forum',
                        'children': [
                            {
                                id: 'site',
                                title: this._translateService.instant('NAV.SITE'),
                                translate: 'NAV.SITE',
                                icon: 'add_location',
                                type: 'item',
                                url: '/sites',
                            },
                            {
                                id: 'sujet',
                                title: this._translateService.instant('NAV.SUJET'),
                                translate: 'NAV.SUJET',
                                icon: 'polymer',
                                type: 'item',
                                url: '/sujets',
                            },
                            {
                                id: 'impact',
                                title: this._translateService.instant('NAV.IMPACT'),
                                translate: 'NAV.IMPACT',
                                icon: 'device_hub',
                                type: 'item',
                                url: '/impacts',
                            },
                            {
                                id: 'incidence',
                                title: this._translateService.instant('NAV.INCIDENCE'),
                                translate: 'NAV.INCIDENCE',
                                icon: 'flash_on',
                                type: 'item',
                                url: '/incidences',
                            },
                            // {
                            //     id: 'frequence',
                            //     title: 'Frequence',
                            //     translate: 'NAV.FREQUENCE',
                            //     icon: 'turned_in_not',
                            //     type: 'item',
                            //     url: '/frequences',
                            // },
                            // {
                            //     id: 'detectabilite',
                            //     title: 'Detectabilite',
                            //     translate: 'NAV.DETECTABILITE',
                            //     icon: 'turned_in_not',
                            //     type: 'item',
                            //     url: '/detectabilites',
                            // },
                            {
                                id: 'preuveEfficacite',
                                title: this._translateService.instant('NAV.PREUVE_EFFICACITE'),
                                translate: 'NAV.PREUVE_EFFICACITE',
                                icon: 'flare',
                                type: 'item',
                                url: '/preuves-efficacite',
                            },
                            {
                                id: 'etatAction',
                                title: this._translateService.instant('NAV.ETAT_ACTION'),
                                translate: 'NAV.ETAT_ACTION',
                                icon: 'disc_full',
                                type: 'item',
                                url: '/etats-action',
                            },
                            {
                                id: 'categorieEmetteur',
                                title: this._translateService.instant('NAV.CATEGORIE_EMETTEUR'),
                                translate: 'NAV.CATEGORIE_EMETTEUR',
                                icon: 'category',
                                type: 'item',
                                url: '/categories-emetteur',
                            },
                            {
                                id: 'question-enquete',
                                title: this._translateService.instant('NAV.BATTERIE_QUESTION'),
                                translate: 'NAV.BATTERIE_QUESTION',
                                icon: 'live_help',
                                type: 'item',
                                url: '/question-enquete',
                            }

                        ]
                    },
                    {
                        'id': 'GED',
                        'title': this._translateService.instant('NAV.GED'),
                        'translate': 'NAV.GED',
                        'type': 'collapsable',
                        'icon': 'folder_open',
                        'children': [
                            {
                                id: 'type-doc-externe',
                                title: this._translateService.instant('NAV.TYPE_DOC_EXTERNE'),
                                translate: 'NAV.TYPE_DOC_EXTERNE',
                                icon: 'chrome_reader_mode',
                                type: 'item',
                                url: '/types-doc-externe',
                            },
                            {
                                id: 'origine-doc-externe',
                                title: this._translateService.instant('NAV.ORIGINE_DOC_EXTERNE'),
                                translate: 'NAV.ORIGINE_DOC_EXTERNE',
                                icon: 'get_app',
                                type: 'item',
                                url: '/origines-doc-externe',
                            },
                            {
                                id: 'partie-interessee',
                                title: this._translateService.instant('NAV.PARTIE_INTERESSEE'),
                                translate: 'NAV.PARTIE_INTERESSEE',
                                icon: 'group_work',
                                type: 'item',
                                url: '/parties-interessees',
                            },
                            {
                                id: 'type-enregistrement',
                                title: this._translateService.instant('NAV.TYPE_ENREGISTREMENT'),
                                translate: 'NAV.TYPE_ENREGISTREMENT',
                                icon: 'save',
                                type: 'item',
                                url: '/types-enregistrement',
                            }
                        ]
                    },
                    {
                        id: 'param_stock',
                        title: this._translateService.instant('NAV.STOCK'),
                        translate: 'NAV.STOCK',
                        type: 'collapsable',
                        icon: 'storage',
                        children: [

                            {
                                id: 'famille',
                                title: this._translateService.instant('NAV.FAMILLE'),
                                translate: 'NAV.FAMILLE',
                                type: 'item',
                                icon: 'layers',
                                url: '/familles'
                            },
                            {
                                id: 'typearticle',
                                title: this._translateService.instant('NAV.TYPE_ARTICLE'),
                                translate: 'NAV.TYPE_ARTICLE',
                                type: 'item',
                                icon: 'label',
                                url: '/typearticles'
                            },
                            {
                                id: 'unite',
                                title: this._translateService.instant('NAV.UNITE'),
                                translate: 'NAV.UNITE',
                                type: 'item',
                                icon: 'straighten',
                                url: '/unites'
                            },
                            {
                                id: 'contactfournisseur',
                                title: this._translateService.instant('NAV.CONTACT_FOURNISSEUR'),
                                translate: 'NAV.CONTACT_FOURNISSEUR',
                                type: 'item',
                                icon: 'contacts',
                                url: '/contactfournisseurs'
                            },
                            {
                                id: 'banque',
                                title: this._translateService.instant('NAV.BANQUE'),
                                translate: 'NAV.BANQUE',
                                type: 'item',
                                icon: 'account_balance',
                                url: '/banques'
                            },
                            {
                                id: 'modepaiement',
                                title: this._translateService.instant('NAV.MODE_PAIEMENT'),
                                translate: 'NAV.MODE_PAIEMENT',
                                type: 'item',
                                icon: 'credit_card',
                                url: '/modepaiements'
                            }

                        ]


                    },
                    {
                        id: 'param_evaluation_fournisseur',
                        title: this._translateService.instant('NAV.EVALUATION_FOURNISSEUR'),
                        translate: 'NAV.EVALUATION_FOURNISSEUR',
                        type: 'collapsable',
                        icon: 'assessment',
                        children: [

                            {
                                id: 'critereevaluationfournisseur',
                                title: this._translateService.instant('NAV.CRITERE_EVALUATION_FOURNISSEUR'),
                                translate: 'NAV.CRITERE_EVALUATION_FOURNISSEUR',
                                type: 'item',
                                icon: 'format_list_numbered',
                                url: '/critereevaluationfournisseurs'
                            },

                        ]


                    },
                    {
                        'id': 'RH',
                        'title': this._translateService.instant('NAV.GRH'),
                        'translate': 'NAV.GRH',
                        'type': 'collapsable',
                        'icon': 'person_pin',
                        'children': [
                            {
                                id: 'etablissement',
                                title: this._translateService.instant('NAV.ETABLISSEMENT'),
                                translate: 'NAV.ETABLISSEMENT',
                                icon: 'location_city',
                                type: 'item',
                                url: '/etablissements',
                            },
                            {
                                id: 'typesDiplomes',
                                title: this._translateService.instant('NAV.TYPE_DIPLOME'),
                                translate: 'NAV.TYPE_DIPLOME',
                                icon: 'school',
                                type: 'item',
                                url: '/types-diplomes',
                            },
                            {
                                id: 'specialite',
                                title: this._translateService.instant('NAV.SPECIALITE'),
                                translate: 'NAV.SPECIALITE',
                                icon: 'cast_for_education',
                                type: 'item',
                                url: '/specialites',
                            },
                            {
                                id: 'domaine_competence',
                                title: this._translateService.instant('NAV.DOMAINE_COMPETENCE'),
                                translate: 'NAV.DOMAINE_COMPETENCE',
                                icon: 'games',
                                type: 'item',
                                url: '/domaines-competence',
                            },
                            {
                                id: 'competence',
                                title: this._translateService.instant('NAV.COMPETENCE'),
                                translate: 'NAV.COMPETENCE',
                                icon: 'extension',
                                type: 'item',
                                url: '/competences',
                            },
                            {
                                id: 'actionFormation',
                                title: this._translateService.instant('NAV.ACTION_FORMATION'),
                                translate: 'NAV.ACTION_FORMATION',
                                icon: 'group_work',
                                type: 'item',
                                url: '/actions-formation',
                            },
                            {
                                id: 'critere-maintien',
                                title: this._translateService.instant('NAV.CRITERE_MAINTIEN'),
                                translate: 'NAV.CRITERE_MAINTIEN',
                                icon: 'share',
                                type: 'item',
                                url: '/criteres-maintien',
                            },
                            {
                                id: 'service',
                                title: this._translateService.instant('NAV.SERVICE'),
                                translate: 'NAV.SERVICE',
                                icon: 'hot_tub',
                                type: 'item',
                                url: '/services',
                            },
                            {
                                id: 'vaccination',
                                title: this._translateService.instant('NAV.VACCINATION'),
                                translate: 'NAV.VACCINATION',
                                icon: 'local_pharmacy',
                                type: 'item',
                                url: '/vaccinations',
                            },
                            {
                                id: 'question',
                                title: this._translateService.instant('NAV.QUESTION_EVALUATION'),
                                translate: 'NAV.QUESTION_EVALUATION',
                                icon: 'help_outline',
                                type: 'item',
                                url: '/question',
                            }
                        ]
                    }
                    /**************GMAO ****************************/

                    , {
                        'id': 'gmaoSub',
                        'title': this._translateService.instant('NAV.GMAO'),
                        'translate': 'NAV.GMAO',
                        'type': 'collapsable',
                        'icon': 'important_devices',
                        'children': [
                            {
                                id: 'marque',
                                title: this._translateService.instant('NAV.Marque'),
                                translate: 'NAV.Marque',
                                icon: 'branding_watermark',
                                type: 'item',
                                url: '/marques',
                            },
                            {
                                id: 'model',
                                title: this._translateService.instant('NAV.Model'),
                                translate: 'NAV.Model',
                                icon: 'insert_drive_file',
                                type: 'item',
                                url: '/models',
                            },
                            {
                                id: 'fournisseur',
                                title: this._translateService.instant('NAV.Fournisseur'),
                                translate: 'NAV.Fournisseur',
                                icon: 'group',
                                type: 'item',
                                url: '/fournisseurs',
                            },
                            // {
                            //     id: 'client',
                            //     title: 'client',
                            //     translate: 'NAV.CLIENT',
                            //     icon: 'group',
                            //     type: 'item',
                            //     url: '/clients',
                            // },
                            {
                                id: 'type',
                                title: this._translateService.instant('NAV.Type'),
                                translate: 'NAV.Type',
                                icon: 'category',
                                type: 'item',
                                url: '/types',
                            },
                            {
                                id: 'criticite',
                                title: this._translateService.instant('NAV.Criticite'),
                                translate: 'NAV.Criticite',
                                icon: 'priority_high',
                                type: 'item',
                                url: '/criticites',
                            },
                            {
                                id: 'etat',
                                title: this._translateService.instant('NAV.ETAT'),
                                translate: 'NAV.ETAT',
                                icon: 'inbox',
                                type: 'item',
                                url: '/etats',
                            },
                            {
                                id: 'champutilisation',
                                title: this._translateService.instant('NAV.CHAMPUTILISATION'),
                                translate: 'NAV.CHAMPUTILISATION',
                                icon: 'business_center',
                                type: 'item',
                                url: '/champutilisations',
                            },
                            {
                                id: 'discipline',
                                title: this._translateService.instant('NAV.DISCIPLINE'),
                                translate: 'NAV.DISCIPLINE',
                                icon: 'ballot',
                                type: 'item',
                                url: '/disciplines',
                            },
                            {
                                id: 'emplacement',
                                title: this._translateService.instant('NAV.EMPLACEMENT'),
                                translate: 'NAV.EMPLACEMENT',
                                icon: 'location_on',
                                type: 'item',
                                url: '/emplacements',
                            },
                            {
                                id: 'priorite',
                                title: this._translateService.instant('NAV.PRIORITE'),
                                translate: 'NAV.PRIORITE',
                                icon: 'low_priority',
                                type: 'item',
                                url: '/priorites',
                            },
                            {
                                id: 'typepanne',
                                title: this._translateService.instant('NAV.TYPEPANNE'),
                                translate: 'NAV.TYPEPANNE',
                                icon: 'bar_chart',
                                type: 'item',
                                url: '/typepannes',
                            },
                            {
                                id: 'typeintervention',
                                title: this._translateService.instant('NAV.TYPEINTERVENTION'),
                                translate: 'NAV.TYPEINTERVENTION',
                                type: 'item',
                                icon: 'group_work',
                                url: '/typeinterventions'
                            },
                            {
                                id: 'typetacheintervention',
                                title: this._translateService.instant('NAV.TYPETACHEINTERVENTION'),
                                translate: 'NAV.TYPETACHEINTERVENTION',
                                type: 'item',
                                icon: 'chrome_reader_mode',
                                url: '/typetacheinterventions'
                            },
                            {
                                id: 'uniteduree',
                                title: this._translateService.instant('NAV.UNITEDUREE'),
                                translate: 'NAV.UNITEDUREE',
                                type: 'item',
                                icon: 'graphic_eq',
                                url: '/unitedurees'
                            },
                            {
                                id: 'statuttache',
                                title: this._translateService.instant('NAV.STATUTTACHE'),
                                translate: 'NAV.STATUTTACHE',
                                type: 'item',
                                icon: 'new_releases',
                                url: '/statuttaches'
                            }
                        ]
                    }

                    /**************GMAO ****************************/
                    /**************RISK ***************************/
                    , {
                        id: 'Gestion_RisquesParam',
                        title: this._translateService.instant('NAV.RISK_MANGEMENT'),
                        translate: 'NAV.RISK_MANGEMENT',
                        type: 'collapsable',
                        icon: 'sync_problem',
                        children: [
                            {
                                id: 'Fréquence',
                                title: this._translateService.instant('NAV.FREQUENCE'),
                                translate: 'NAV.FREQUENCE',
                                icon: 'autorenew',
                                type: 'item',
                                url: '/frequences'
                            },
                            {
                                id: 'Gravité',
                                title: this._translateService.instant('NAV.SEVERITY'),
                                translate: 'NAV.SEVERITY',
                                icon: 'flash_on',
                                type: 'item',
                                url: '/severities',
                            },
                            {
                                id: 'Détectabilité',
                                title: this._translateService.instant('NAV.DETECTABILITE'),
                                translate: 'NAV.DETECTABILITE',
                                icon: 'remove_red_eye',
                                type: 'item',
                                url: '/detectabilites',
                            },
                            {
                                id: 'Criticité',
                                title: this._translateService.instant('NAV.CRITICALITY'),
                                translate: 'NAV.CRITICALITY',
                                icon: 'report_problem',
                                type: 'item',
                                url: '/criticalities',
                            },
                            {
                                id: 'HighRiskParam',
                                title: this._translateService.instant('NAV.HIGHRISKPARAMS'),
                                translate: 'NAV.HIGHRISKPARAMS',
                                icon: 'settings_applications',
                                type: 'item',
                                url: '/params',
                            }
                        ],
                    },
                    /**************AUDIT ***************************/
                    {
                        id: 'audits',
                        title: this._translateService.instant('NAV.AUDIT'),
                        translate: 'NAV.AUDIT',
                        type: 'collapsable',
                        icon: 'check_circle',
                        children: [
                            {
                                id: 'Norme',
                                title: this._translateService.instant('NAV.NORME'),
                                translate: 'NAV.NORME',
                                icon: 'assignment_turned_in',
                                type: 'item',
                                url: '/normes'
                            },
                            {
                                id: 'Chapitre',
                                title: this._translateService.instant('NAV.CHAPITRE'),
                                translate: 'NAV.CHAPITRE',
                                icon: 'library_books',
                                type: 'item',
                                url: '/chapitres'
                            },
                            // {
                            //     id: 'SousChapitre',
                            //     title: 'SousChapitre',
                            //     translate: 'SousChapitre',
                            //     icon: 'subdirectory_arrow_right',
                            //     type: 'item',
                            //     url: '/souschapitres'
                            // },


                        ],
                    },
                    /**************AUDIT ***************************/


                    {
                        id: 'documentation',
                        title: this._translateService.instant('NAV.DOCUMENTATION'),
                        translate: 'NAV.DOCUMENTATION',
                        type: 'item',
                        icon: 'help_outline',
                        url: '/documentation'


                    }
                ]
            });
        }

          if (data.authorities.some(authority => authority.includes(PrivilegeEnum.TODO))) {
            navigations.push({
                id: 'todos',
                title: this._translateService.instant('NAV.TODOS'),
                translate: 'Todo',
                type: 'item',
                icon: 'check_circle',//visibility
                url: '/calendar-todo'
            });
        }


        if (data.authorities.includes(CONTROLE_ACCES)) {
            navigations.push({
                'id': 'gestion_acces',
                'title': this._translateService.instant('NAV.GESTION_ACCES'),
                'translate': 'NAV.GESTION_ACCES',
                'type': 'collapsable',
                'icon': 'input',
                'children': [{
                    id: 'user',
                    title: this._translateService.instant('NAV.USERS'),
                    translate: 'NAV.USERS',
                    type: 'item',
                    icon: 'person',
                    url: '/users'
                },
                {
                    id: 'role',
                    title: this._translateService.instant('NAV.ROLES'),
                    translate: 'NAV.ROLES',
                    type: 'item',
                    icon: 'how_to_reg',
                    url: '/roles'
                }, {
                    id: 'groupe',
                    title: this._translateService.instant('NAV.GROUPE'),
                    translate: 'NAV.GROUPE',
                    type: 'item',
                    icon: 'group',
                    url: '/groupes'
                }
                ]
            });
        }


            
         

        /************** TO DO ****************************/
        // if (data.authorities.some(authority => authority.includes(PrivilegeEnum.TODO))) {
        /*
        navigations.push({
           id: 'todos',
           title:this._translateService.instant( ,
           translate: 'NAV.TODO',
           type: 'collapsable',
           icon: 'check_box',
           'children': [{
               id: 'todo',
               title:this._translateService.instant( ,
               translate: 'NAV.TODO',
               type: 'item',
               icon: 'check_box',
               url: '/todos'
           },
          ]
       
       });
       */
        // }
        /**************TO DO ****************************/
        // if (data.authorities.includes(MONITORING)) {
        //     navigations.push({
        //         id: 'monitoring',
        //         title: 'Monitoring',
        //         translate: 'NAV.MONITORING',
        //         icon: 'queue_play_next',
        //         type: 'item',
        //         url: '/monitoring',
        //     });
        // }

        // var navigationItem = {
        //     id: 'applications',
        //     type: 'group',
        //     children: navigations
        // };

        // this._fuseNavigationService.addNavigationItem(navigationItem, 'start');

        this.navigation = navigations;

        this._fuseNavigationService.unregister('main');

        this._fuseNavigationService.register('main', this.navigation);

        // Set the current navigation
        this._fuseNavigationService.setCurrentNavigation('main');
    }
}
